import {
  GUIDE_STATUS_LABELS,
  GUIDE_VISIBILITY_LABELS,
  type GuideStatus,
  type GuideVisibility,
} from "@shared/modules/guides";
import { Badge } from "../../../core/components/ui/badge";

const VISIBILITY_VARIANT: Record<GuideVisibility, "success" | "primary" | "warning"> = {
  public: "success",
  members: "primary",
  admins: "warning",
};

export function GuideVisibilityBadge({ visibility }: { visibility: GuideVisibility }) {
  return <Badge variant={VISIBILITY_VARIANT[visibility]}>{GUIDE_VISIBILITY_LABELS[visibility]}</Badge>;
}

export function GuideStatusBadge({ status }: { status: GuideStatus }) {
  return <Badge variant={status === "published" ? "success" : "neutral"}>{GUIDE_STATUS_LABELS[status]}</Badge>;
}
